import { graphql } from "gql";

const HAPPYCO_UNITS_QUERY = graphql(`
  query HappycoUnits($propertyId: String!) {
    happycoUnits(propertyId: $propertyId) {
      ...HappycoUnit
    }
  }
`);

export default HAPPYCO_UNITS_QUERY;
